export default __webpack_public_path__ + "static/media/disconnectIcon.f8b9a1a5.svg";